import React, { Component, Fragment } from 'react';
import { DatePicker, message } from 'antd';
import { isNil } from 'lodash';
import dayjs from 'dayjs';
import locale from 'antd/locale/ko_KR';
import Modal from '../../Modal';
import Button from '../../Button';
import moment, { setDateFormat } from '../../../lib/moment';
import { comparePrePropsAndNextProps } from '../../../lib/common';
import { setDateSinglePickerBtnText } from '../../../lib/utils/commonUtils';
import { DATE_PICKER_DEFAULT_PLACEHOLDER_TEXT } from '../../../constants/service/common/utilConstants';
import './DateSinglePicker.scss';

// moment와 dayjs 간 변환 유틸리티
const momentToDayjs = (m) => (m ? dayjs(m.valueOf()) : null);
const dayjsToMoment = (d) => (d ? moment(d.valueOf()) : null);

class DateSinglePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      selectedDay: props.value ? moment(props.value) : null,
    };
  }

  /**
   * Props 값이 변경이 되었을 때, state 의 값을 변경
   */
  UNSAFE_componentWillReceiveProps(props) {
    if (
      comparePrePropsAndNextProps([
        [[props.value ? moment(props.value).valueOf() : null], [moment(this.state.startDate).valueOf()]],
      ])
    ) {
      this.setState({
        selectedDay: props.value ? moment(props.value) : null,
      });
    }
  }

  toggleModal = () => {
    const { value } = this.props;
    this.setState({
      isOpen: !this.state.isOpen,
      selectedDay: value ? moment(value) : null,
    });
  };

  onChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  onDateChange = (dayjsValue) => {
    // dayjs 값을 moment로 변환하여 저장
    const momentValue = dayjsToMoment(dayjsValue);
    this.onChange('selectedDay', momentValue);
  };

  /**
   * outsideRange 값에 따라서
   * Date 를 선택하지 못하는 날짜 설정
   * antd v5에서 disabledDate는 dayjs 객체를 받음
   */
  disableDate = (dayjsDate) => {
    const { outsideRange } = this.props;
    if (!dayjsDate) return false;

    /**
     *  outsideRange 가 존재한다면, before 제한 추가
     */
    if (outsideRange) {
      let condition;
      if (outsideRange.before) {
        condition = dayjsDate.valueOf() < dayjs(outsideRange.before).valueOf();
      }

      if (outsideRange.after) {
        condition = dayjsDate.valueOf() > dayjs(outsideRange.after).valueOf();
      }
      return condition;
    } else return false;
  };

  onSelect = () => {
    const { onSelect, outFormat, required = true } = this.props;
    const { isOpen, selectedDay } = this.state;

    /**
     *  날짜를 선택했는지 체크(required일 경우에만)
     */
    if (!selectedDay && required) {
      message.error('날짜를 선택해주세요.');
      return;
    }

    this.setState({
      isOpen: !isOpen,
    });

    onSelect(setDateFormat(selectedDay, outFormat));
  };

  render() {
    const { isOpen, selectedDay } = this.state;
    const {
      value,
      dayText = DATE_PICKER_DEFAULT_PLACEHOLDER_TEXT,
      showTime,
      format = 'LL',
      btnTextFormat,
      isEditable = true,
      disabledTime,
      disabledDate,
      allowClear = false,
    } = this.props;

    /**
     *  버튼 텍스트 문구에 들어갈 선택된 날짜 데이터 또는 기본 데이터
     */
    const btnText = setDateSinglePickerBtnText(btnTextFormat, isNil(value) || value === '' ? null : moment(value));

    // moment를 dayjs로 변환하여 DatePicker에 전달
    const selectedDayDayjs = momentToDayjs(selectedDay);

    // disabledDate props가 있으면 dayjs 호환 래퍼 함수 생성
    const wrappedDisabledDate = disabledDate ? (dayjsDate) => disabledDate(dayjsToMoment(dayjsDate)) : this.disableDate;

    return (
      <Fragment>
        <Modal
          title="날짜 선택하기"
          isOpen={isOpen}
          width={610}
          height={460}
          isFooter={true}
          overflow="hidden"
          onOk={() => this.onSelect()}
          destroyOnClose={true}
          onClose={() => this.toggleModal()}
        >
          <div className="date-single-picker-modal">
            <DatePicker
              disabledDate={wrappedDisabledDate}
              disabledTime={disabledTime}
              locale={locale}
              showTime={showTime}
              format={format}
              value={selectedDayDayjs}
              placeholder={dayText}
              onChange={this.onDateChange}
              allowClear={allowClear}
            />
          </div>
        </Modal>

        {/* 날짜를 선택하는 모달을 열고 닫는 버튼*/}
        <Button
          className="date-single-picker-button"
          color="light"
          disabled={!isEditable}
          text={btnText}
          onClick={() => this.toggleModal()}
        />
      </Fragment>
    );
  }
}

export default DateSinglePicker;
